import dayjs from 'dayjs';

interface IFormatDeadline {
  deadline: string;
}

/**
 * 채용 공고 마감 일시를 `2026. 08. 17, 08:59` 형태로 포맷한다.
 */
export const formatDeadline = ({ deadline }: IFormatDeadline) =>
  dayjs(deadline).format('YYYY. MM. DD, HH:mm');

interface IGetRemainingDays {
  deadline: string;
  now?: Date;
}

/**
 * 마감일까지 남은 일수를 반환한다.
 * 마감 당일은 0, 이미 마감된 경우 null을 반환한다.
 */
export const getRemainingDays = ({
  deadline,
  now = new Date(),
}: IGetRemainingDays) => {
  const days = dayjs(deadline)
    .startOf('day')
    .diff(dayjs(now).startOf('day'), 'day');
  return days < 0 || dayjs(deadline).isBefore(now) ? null : days;
};
